export const Environment = {
  name: 'development',
  production: false,
  urls: {
    API: 'https://dev-jems3.sbc.org.br/api'
  },
  recaptcha: {
    siteKey: '6LcDWP8sAAAAAOW6dJG-lhcg09tKqYoX3OUMxKJ-'
  }
};
